const TravelComponent = () => import('@/views/finance/travel/travelView')

export default [
    {
        path:'/TravelIndex',
        name:'TravelComponent',
        component:TravelComponent
    }
]